import * as React from 'react';

const SOURCE_KEY = 'my_home_source';

export const useSaveSource = () => {
  React.useEffect(() => {
    if (window) {
      const url = new URL(window.location.href);

      const source = url.searchParams.get('from');

      if (source) {
        localStorage.setItem(SOURCE_KEY, source);
      }
    }
  }, []);
};
